import * as actionTypes from './errorActionTypes';

const updateErrorAction = (isError: boolean) => (dispatch: any) =>{
    dispatch({ type: actionTypes.UPATE_ERROR, isError })}

export { updateErrorAction };